export default {
    addOffPlan:'/index.php/cqh/Offplan/add',//保存修改计划外项目
    offPlanLists:'/index.php/cqh/Offplan/lists',//计划外项目列表
    offPlanDetail:'/index.php/cqh/Offplan/detail',//计划外项目详情
    deleteOffPlan:'/index.php/cqh/Offplan/delete',//删除计划外项目
    listsExport:'/index.php/cqh/Offplan/listsExport',//计划外项目列表导出
    Offplanstatistics:'/index.php/cqh/Offplan/statistics',//获取物资统计
}